import { render, staticRenderFns } from "./BuildBasicDataManagement.vue?vue&type=template&id=0aafef9a&scoped=true"
import script from "./BuildBasicDataManagement.vue?vue&type=script&lang=js"
export * from "./BuildBasicDataManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=0aafef9a&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/tableList.scss?vue&type=style&index=1&id=0aafef9a&prod&lang=scss&scoped=true&external"
import style2 from "./BuildBasicDataManagement.vue?vue&type=style&index=2&id=0aafef9a&prod&lang=scss&scoped=true"
import style3 from "./BuildBasicDataManagement.vue?vue&type=style&index=3&id=0aafef9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aafef9a",
  null
  
)

export default component.exports